import React, { useEffect } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { useIntl } from 'react-intl';
import { useQuill } from 'react-quilljs';
import cx from 'classnames';
import quillSnowCss from 'quill/dist/quill.snow.css';
import customQuillCss from '../../../styles/customQuillEditor.css';
import { EMAIL_PLACEHOLDERS_BY_TYPE } from './placeholderMap';
import messages from '../../../locale/jsonMessages';
import bt from '../../../components/commonStyle.css';

function BodyEditorInner({ type, value, onChange, onQuillReady }) {
  const intl = useIntl();
  const editorPlaceholder = intl.formatMessage(messages.emailTemplateEditorPlaceholder);
  const insertDynamicValueLabel = intl.formatMessage(messages.emailTemplateInsertDynamicValue);

  const formats = ['header', 'size', 'bold', 'italic', 'underline', 'strike', 'indent', 'link', 'align'];

  const { quill, quillRef } = useQuill({
    modules: {
      toolbar: [
        [{ header: 1 }, { header: 2 }, { header: 3 }, { header: 4 }],
        [{ size: ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ indent: '-1' }, { indent: '+1' }],
        ['link'],
        [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }]
      ],
      clipboard: { matchVisual: false },
    },
    placeholder: editorPlaceholder,
    formats: formats

  });

  useEffect(() => {
    if (!quill) return;
    quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
        // Remove <img> tags completely
      if (node.tagName === 'IMG') {
        return { ops: [] }; // remove image
      }
      delta.ops.forEach((op) => {
        if (op.insert && op.insert.image) {
          return false;
        }
        if (op.attributes) {
          delete op.attributes.color;
          delete op.attributes.background;
        }
      });
      return delta;
    });
    quill.clipboard.dangerouslyPasteHTML(value || '');
    if (onQuillReady) onQuillReady(quill);

    const handler = (delta, oldDelta, source) => {
      if (source !== 'user') return;
      const text = quill.getText().trim();
      const html = text === ''
        ? '<p> </p>'
        : quill.root.innerHTML;
      onChange(html);
    };
    quill.on('text-change', handler);
    return () => quill.off('text-change', handler);
  }, [quill]);


  const handlePlaceholderSelect = (e) => {
    const key = e.target.value;
    if (!key || !quill) return;
    const index = quill.getSelection?.()?.index ?? quill.getLength();
    quill.insertText(index, `{{${key}}}`);
    e.target.value = '';
  };

  const placeholders = (type && EMAIL_PLACEHOLDERS_BY_TYPE[type]) || [];

  return (
    <div>
      <div className={cx('twoColumnGrid', bt.spaceBottom3)}>
        <select
          className='commonSelectField'
          onChange={handlePlaceholderSelect}
          defaultValue=""
          aria-label={insertDynamicValueLabel}
        >
          <option value="">{insertDynamicValueLabel}</option>
          {placeholders.map(({ key, labelKey }) => (
            <option key={key} value={key}>
              {intl.formatMessage(messages[labelKey])} ({'{{' + key + '}}'})
            </option>
          ))}
        </select>
      </div>
      <div className='commonQuillBox'>
        <div ref={quillRef} />
      </div>
    </div>
  );
}

export default withStyles(quillSnowCss, customQuillCss, bt)(BodyEditorInner);
